import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Delete } from '@quintoandar/cozy-icons/Delete';
import Button from '@quintoandar/cozy-core/Button';
import { LoadingWrapper } from './elements';
import messages from './messages';

export const LoadingButton = ({
  isLoading,
  onClickFunction,
}) => (
  <LoadingWrapper mt={6} mb={6} display="flex" justifyContent="center">
    <Button
      variant="destructive"
      onClick={onClickFunction}
      icon={Delete}
      isLoading={isLoading}
      fullWidth
    >
      <FormattedMessage {...messages.deleteAll} />
    </Button>
  </LoadingWrapper>
);

LoadingButton.propTypes = {
  onClickFunction: PropTypes.func,
  isLoading: PropTypes.bool,
};
